<template>
  <b-container class="p-3" fluid>
    <b-row>
      <b-col>
        <div class="filter form-inline mb-3">
          <search-box v-model="search" placeholder="พิมพ์เพื่อค้นหา" />
          <div class="ml-auto">
            <b-button variant="primary" :to="{ name: 'settings.groups.create'}">
              <font-awesome-icon icon="plus-circle" />สร้างหน่วยงาน
            </b-button>
          </div>
        </div>

        <group-list-table :groups="groups.data" :search-term="searchTerm" />
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import GroupListTable from '@/components/settings/groups/GroupListTable'
import SearchBox from '@/components/shared/SearchBox'

import gql from 'graphql-tag'

export default {
  apollo: {
    groups: {
      query: gql`{ groups(page:1, count:10000) { data { id,name,type } } }`,
      fetchPolicy: 'no-cache'
    }
  },
  components: {
    GroupListTable,
    SearchBox
  },
  data () {
    return {
      searchTerm: null,
      groups: {
        data: []
      }
    }
  },
  computed: {
    search: {
      get () { return this.searchTerm },
      set (value) {
        this.searchTerm = value
      }
    }
  }
}
</script>
